import { useFormik } from 'formik';
import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import * as Yup from 'yup';

import { Spacer } from '../../components/spacer';
import { Button } from '../../components/styled/button';
import { ErrorText, InputField } from '../../components/styled/input';
import { Auth, AuthCard, Main } from '../../components/styled/layout';
import Logo from '../../components/styled/logo';
import { Heading, Text } from '../../components/styled/text';
import { magicLogin } from '../../endpoints/auth';
import useUser from '../../hooks/use-user';

const schema = Yup.object().shape({
  destination: Yup.string()
    .email('Ongeldig e-mailadres')
    .required('Verplicht veld'),
});

export default function Login() {
  const router = useRouter();
  const { error: callbackError } = router.query;
  const [loginError, setLoginError] = useState(null);
  const [verificationCode, setVerificationCode] = useState(null);
  useUser({ redirectTo: '/knowledge-base', redirectIfFound: true });

  const formik = useFormik({
    validationSchema: schema,
    initialValues: {
      destination: '',
    },
    onSubmit: async (values, form) => {
      setLoginError(null);
      try {
        const body = await magicLogin(values);
        if (body.success) {
          setVerificationCode(body.code);
        } else {
          setLoginError(`Er ging iets fout`);
        }
      } catch (err) {
        console.error(err);
        setLoginError(`Er ging iets fout`);
      } finally {
        form.setSubmitting(false);
      }
    },
  });

  function back(e) {
    e.preventDefault();
    setVerificationCode(null);
  }

  return (
    <>
      <Head>
        <title>Inloggen</title>
      </Head>
      <Main>
        <Auth>
          <Spacer size={4} />
          <Logo />
          <Spacer size={4} />
          <form onSubmit={formik.handleSubmit}>
            <AuthCard>
              <Heading size="h1">Inloggen voor leden</Heading>
              <Spacer size={1} />
              {verificationCode ? (
                <>
                  <Text align="center">
                    We hebben je een e-mail gestuurd waarmee je kan inloggen.
                    Controleer de verificatie code: {verificationCode}
                  </Text>
                  <Spacer size={2} />
                  <Button type="button" onClick={back}>
                    Terug
                  </Button>
                </>
              ) : (
                <>
                  {callbackError ? (
                    <>
                      <ErrorText>{callbackError}</ErrorText>
                      <Spacer size={2} />
                    </>
                  ) : null}
                  <InputField
                    id="destination"
                    name="destination"
                    type="email"
                    onChange={formik.handleChange}
                    value={formik.values.destination}
                    placeholder="Zakelijke e-mailadres (@organisatie.nl)"
                    label="Zakelijke e-mailadres (@organisatie.nl)"
                    error={formik.errors.destination || loginError}
                  />
                  <Spacer size={2} />
                  <Button
                    type="submit"
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    {formik.isSubmitting ? 'Laden...' : 'Inloggen'}
                  </Button>
                </>
              )}
              <Spacer size={1} />
              <Text secondary>
                <Link href="/auth/register">
                  <a>Nog geen lid? Klik hier om te registreren</a>
                </Link>
              </Text>
            </AuthCard>
          </form>
          <Spacer size={1} />
          <Text secondary>
            Heb je hulp nodig? Je kunt ons bereiken via{' '}
            <Link href="mailto:info@corporatienl.nl">
              <a>info@corporatienl.nl</a>
            </Link>
          </Text>
        </Auth>
      </Main>
    </>
  );
}
